import gql from "graphql-tag";

export default gql`
  query getSiteSubRoleSiteId($siteId: String! $nextToken: String) {
    getSiteSubRoleSiteId(siteId: $siteId nextToken: $nextToken) {
      items {
        id
        siteId
        name
        emailId
        mobile
        username
        userRole
        password
        # typeValue
        enabled
        attachedMenus
        attachedCounters
        attachedRefCounters
        createdAt
        assignedTables
        updatedAt
        isCaptain
        assignedSites
        permissions {
          name
          operations
        }
        discountCap {
          discountType
          discountValue
        }
      }
      nextToken
    }
  }
`;
